import { ApplicantUser } from "apps/applicants/models/applicant";
import { JobOffer } from "apps/job_offers/models/job_offer";

export class BookmarkedOffer {

    constructor(data){

        this.id                 = data.id
        this.applicant          = new ApplicantUser(data.applicant_data.user_data, data.applicant_data)
        this.job_offer          = new JobOffer(data.job_offer_data)
        this.created_date       = data.created_date
    }    

}